import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import axios from "axios";

interface StockUpdateData {
  id: string;
  quantity: number;
}

export const savePublicHolidayOrWeekend = createAsyncThunk(
  "holidays/createPublicHolidayOrWeekend",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "holidays/createPublicHolidayOrWeekend",
        data
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

export const deleteWeekends = createAsyncThunk(
  "holidays/deleteweekends",
  async (day: string, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`holidays/deleteweekends/${day}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

export const savePublicHolidayOrWeekendList = createAsyncThunk(
  "holidays/createMultipleHolidays",
  async (data: any[], { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "holidays/createMultipleHolidays",
        data
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
        action: error.response.data.action,
        data: error.response.data.data,
      });
    }
  }
);

export const findPublicHolidayOrWeekend = createAsyncThunk(
  "holidays/findPublicHolidaysAndWeekends",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `holidays/findPublicHolidaysAndWeekends/${id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);

export const updatePublicHolidayOrWeekend = createAsyncThunk(
  "holidays/updateHoliday",
  async ({ id, data }: any, { rejectWithValue }) => {
    try {
      const response = await axios.put(`holidays/updateHoliday/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);

export const deletePublicHolidayOrWeekend = createAsyncThunk(
  "holidays/deletePublicHolidayOrWeekend",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `holidays/deletePublicHolidayOrWeekend/${id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);

interface PublicHolidayOrWeekend {
  publicHolidaysAndWeekendsList: any[];
}

const initialState: PublicHolidayOrWeekend = {
  publicHolidaysAndWeekendsList: [],
};

export const publicHolidaysAndWeekendsSlice = createSlice({
  name: "publicHolidaysAndWeekends",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(savePublicHolidayOrWeekend.fulfilled, (state, action) => {
      let newHolidayOrWeekend = action.payload.data;
      state.publicHolidaysAndWeekendsList.splice(0, 0, newHolidayOrWeekend);
    });

    builder.addCase(findPublicHolidayOrWeekend.fulfilled, (state, action) => {
      return {
        ...state,
        publicHolidaysAndWeekendsList: action.payload.data,
      };
    });

    builder.addCase(updatePublicHolidayOrWeekend.fulfilled, (state, action) => {
      const index = state.publicHolidaysAndWeekendsList.findIndex(
        (item) => item.id === action.payload.data.id
      );
      if (index !== -1) {
        const updatedList = [...state.publicHolidaysAndWeekendsList];
        updatedList[index] = {
          ...updatedList[index],
          ...action.payload.data,
        };
        return {
          ...state,
          publicHolidaysAndWeekendsList: updatedList,
        };
      }
      return state;
    });
  },
});

export const ListPublicHolidaysAndWeekends = (state: RootState) =>
  state.holidays.publicHolidaysAndWeekendsList;

export default publicHolidaysAndWeekendsSlice.reducer;
